module.exports = __webpack_public_path__ + "img/reservoirs-of-quiet.64779a5b.jpg";